export default "__VITE_ASSET__cb12da72__"